<script lang="ts" module>
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { ButtonVariant } from "../../../../core/schema/ButtonVariant.js";
	import { isEnum } from "@core/utils/enum/isEnum.js";
	import type { ButtonIcon } from "./ButtonIcon.js";
	import ButtonIconPart from "./ButtonIconPart.svelte";
	import { getButtonClass } from "./getButtonClass.js";
	import { type LinkVariant, getLinkClass } from "./getLinkClass.js";

	const isButtonVariant = isEnum(ButtonVariant);
</script>

<script lang="ts">
	const {
		variant,
		icon = "none",
		...rest
	}: HTMLAnchorAttributes & {
		icon?: ButtonIcon;
		variant?: ButtonVariant | LinkVariant;
		download?: string; // Retype (is any for some reason)
		href: string; // Make required (accessibilty)
	} = $props();
</script>

<a
	{...rest}
	class={[
		isButtonVariant(variant) ? getButtonClass(variant) : getLinkClass(variant),
		"group inline-flex items-center leading-none",
		icon !== "none" && "gap-2 md:gap-5",
		rest.class,
	]}
>
	<AriaText aria={rest["aria-label"] ?? ""}>
		{@render rest.children?.()}
	</AriaText>
	<ButtonIconPart {icon} />
</a>
